<template>
	<div class="display-flex flex-column width-100">
		<ActionDetailsItem v-for="action in combinedActions" :key="action.id" :action="action" :noBorder="actions.length === 1" />
	</div>
</template>

<script>
import ActionDetailsItem from '@/views/Flow/configurations/SetupMenu/CredentialsSelector/ActionDetailsItem';
export default {
	name: 'ActionsDetailsMenu',
	components: { ActionDetailsItem },
	props: { actions: { type: Array } },
	computed: {
		combinedActions() {
			const allActionTitles = [];
			return this.actions?.filter((action) => {
				const actionTitle = action.action_title;
				if (allActionTitles.includes(actionTitle)) {
					return false;
				} else {
					allActionTitles.push(actionTitle);
					return true;
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped></style>
